import styled from "styled-components";
import DesignConstants from "../../../constants/DesignConstants";

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    gap: ${DesignConstants.SPACES.XS};
    padding: ${DesignConstants.SPACES.S};
    background: white;
    border-radius: ${DesignConstants.BORDER_RADIUS.SMALL_CONTAINER};

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

export const LabelWrapper = styled.div``;

export const Label = styled.p`
    border: ${DesignConstants.BORDERS.MEDIUM};
    border-color: transparent;
    pointer-events: none;
    user-select: none;
    font-size: ${DesignConstants.FONT_SIZES.L};
    font-weight: ${DesignConstants.FONT_WEIGHTS.SEMI_BOLD};
`;
